/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';
import { type LogAtivacao } from '../empresa/types';

const getLogsAtivacaoPorEmpresasId = (empresasId: number): AxiosPromise<LogAtivacao[]> => xhr.get(`/empresas/${empresasId}/logs-ativacao`);

export default getLogsAtivacaoPorEmpresasId;
